import { HttpStatusCode, isPlainObject } from "@next-platform/packages-ts-types";
import { axiosClient, getBaseUrlVersioned } from "../../services/axiosClient";
import { API_VERSION } from "../types";
import { PageBlockTransportErrorCategory } from "./PageBlockTransportErrorCategory";
import readPageBlockTransportFailure from "./readPageBlockTransportFailure";
const API_PATH_CHARACTER = "characters";
function isCharacterPayload(value) {
    const candidateId = value["id"];
    const candidateName = value["name"];
    return typeof candidateId === "string" && candidateId.length > 0 && typeof candidateName === "string" && candidateName.length > 0;
}
/** Never retries and never touches the Redux character slice, so it cannot leak into the chat page. */
export default async function fetchChatbotProfile({ characterId, language, signal, }) {
    const apiUrl = `${getBaseUrlVersioned(API_VERSION.V2)}/${API_PATH_CHARACTER}/${encodeURIComponent(characterId)}`;
    try {
        const response = await axiosClient.get(apiUrl, { params: language ? { language } : undefined, signal });
        if (!isPlainObject(response.data)) {
            return { status: "error", category: PageBlockTransportErrorCategory.UNEXPECTED, httpStatus: response.status };
        }
        return isCharacterPayload(response.data) ? { status: "success", character: response.data } : { status: "not-found" };
    }
    catch (requestError) {
        const failure = readPageBlockTransportFailure(requestError);
        return failure.status === "error" && failure.httpStatus === HttpStatusCode.NOT_FOUND ? { status: "not-found" } : failure;
    }
}
